import { render, staticRenderFns } from "./noDataPic.vue?vue&type=template&id=be34ff7a&scoped=true&"
import script from "./noDataPic.vue?vue&type=script&lang=js&"
export * from "./noDataPic.vue?vue&type=script&lang=js&"
import style0 from "./noDataPic.vue?vue&type=style&index=0&id=be34ff7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be34ff7a",
  null
  
)

export default component.exports